import { httpService } from './http.service';
import { socketService } from './socket.service';
import { jwtDecode } from 'jwt-decode'; // Importación correcta de jwtDecode



const STORAGE_KEY_LOGGEDIN_USER = 'loggedinUser';
const BASE_URL = 'usuarios/';


export const userService = {
    login,
    logout,
    signup,
    getLoggedinUser,
    saveLocalUser,
    getUsers,
    getUsusarios,
    getById,
    remove,
    updateUsers,
    updateResponsables,
    update,
    redirectToLogin,
    GuardarUsuario,
    actualizardatosUsuario,
    AgregarRolUsers,
    UpdateRolUsers


  
};

window.userService = userService;



export const ROLES = {
    ADMIN: 'Administracion',
    TECNICO: 'Unidades Tecnicas',
    AUDITOR: 'Auditor'
};

// export function hasPermission(role) {
//     const ROLES = {
//         ADMIN: 'Administracion',
//         TECNICO: 'Unidades Tecnicas',
//         INVITADO: 'Invitados',
//     };

//     switch (role) {
//         case ROLES.ADMIN:
//             return true; // ADMIN tiene todos los permisos
//         case ROLES.TECNICO:
//             return false; // TECNICO tiene permisos limitados, ajusta según sea necesario
//         case ROLES.INVITADO:
//             return false; // INVITADO solo puede ver, ajusta según sea necesario
//         default:
//             return false; // Rol desconocido o no definido
//     }
// }

function getUsers() {
    return httpService.get(BASE_URL);
}

//funcion para actualizar datos del usuario
function GuardarUsuario(datauser) {
    const queryParams = `guardar`;
    return httpService.post("usuarios/"+queryParams,datauser);
}

//funcion para actualizar datos del usuario
function actualizardatosUsuario(datauser) {
    const queryParams = `actualizar`;
    return httpService.put(`usuarios/${queryParams}/${datauser.id_usuario}`,datauser);
}

function AgregarRolUsers(datarol) {
    const queryParams = `guardar`;
    return httpService.post("roles/"+queryParams,datarol);
}

function UpdateRolUsers(datarol) {
    const queryParams = `actualizar`;
    return httpService.put(`roles/${queryParams}/${datarol.fk_usuario_id}`,datarol);
}
//aqui voy
function getUsusarios(id_Region) {
    const queryParams = `todo`;
    return httpService.get(`usuarios/${queryParams}/${id_Region}`);
}

function updateUsers(responsable) {
    const queryParams = `guardar`;
    return httpService.post("responsable/" + queryParams, responsable);
}

function updateResponsables(responsable, queryParam){
    return httpService.post("responsable/" + queryParam, responsable);
}

async function getById(userId) {
    return httpService.get(BASE_URL + userId);
}

function remove(userId) {
    return httpService.delete(BASE_URL + userId);
}

async function update({user}) {
    if (user._id) return httpService.put(BASE_URL + user._id, user);
    return httpService.post(BASE_URL, user);
}

async function login(credentials) {
    const response = await httpService.post('loginuser/login', credentials);
    if (response.success) {
        const token = response.token;
        const decoded = jwtDecode(token);
        const user = {
            token: token,
            data: decoded.data
        };
        saveLocalUser(user);
        return user;
    } else {
        throw new Error('Invalid credentials');
    }
}

async function signup(userCred) {
    const user = await httpService.post('auth/signup', userCred);
    socketService.login(user._id);
    return saveLocalUser(user);
}

async function logout() {
    sessionStorage.removeItem(STORAGE_KEY_LOGGEDIN_USER);
    // socketService.logout();
    // return await httpService.post('auth/logout');
}

function saveLocalUser(user) {
    sessionStorage.setItem(STORAGE_KEY_LOGGEDIN_USER, JSON.stringify(user));
    return user;
}

function getLoggedinUser() {
    const storedUser = JSON.parse(sessionStorage.getItem(STORAGE_KEY_LOGGEDIN_USER));
    if (!storedUser || !storedUser.token) {
        redirectToLogin();
        return null;
        
    }
    
    try {
        const decodedUser = jwtDecode(storedUser.token);
        const user = {
            data: decodedUser, // Datos del usuario decodificado
            token: storedUser.token // Token JWT
        };
        return user;
    } catch (error) {
        console.error("Error al decodificar el token:", error);
       
        return null;
    }
}

function redirectToLogin() {
    window.location.href = '/'; // Redireccionar al login
}